<template>
	<b-card>
		<template #header>
			<span style="font-size: 20px; font-weight: bold">Бригада</span>
			<b-button @click="create=true;docForm={};createOrEditModal=true" variant="outline-primary" class="fa fa-plus float-right shadow"/>
		</template>
		<b-overlay :show="loading" rounded="sm">
			<b-row>
				<b-col v-for="item in docs" cols="3" class="mt-3">
					<div class="shadow" style="border-radius: 20px; padding: 10px">
						<b>Название : </b> <span>{{ item.name }}</span> <span @click="create=false;docForm=Object.assign({}, item);createOrEditModal=true" class="float-right text-primary pointer-event" style="border-radius: 50%; padding: 0 4px 0 4px; border: 1px solid #0b4d75"><i class="fa fa-pencil"/></span>
					</div>
				</b-col>
			</b-row>
		</b-overlay>

		<!--      Create Or Edit Doc      -->
		<b-modal v-model="createOrEditModal" :title="create ? `Создать` : `Редактировать`" hide-footer :busy="loading" no-close-on-backdrop no-close-on-esc>
			<b-overlay :show="loading" rounded="sm">
				<b-row>
					<b-col>
						<b-input-group prepend="Название">
							<b-form-input v-model="docForm.name"/>
						</b-input-group>
					</b-col>
				</b-row>
				<hr>
				<b-row>
					<b-col align="right">
						<b-button @click="cancel" variant="outline-danger" class="mr-2">Отменить</b-button>
						<b-button @click="save" variant="warning" class="mr-2">Сохранить</b-button>
					</b-col>
				</b-row>
			</b-overlay>
		</b-modal>
	</b-card>
</template>

<script>
import {BOverlay} from 'bootstrapVue2';
import SkyShopService from './skyshop.service';
import UsersService from "../../services/users.sevice";
import FboxService from "../../services/fbox.service";

export default {
	components: {BOverlay},
	data() {
		return {
			loading: false,
			docs: [],
			createOrEditModal: false,
			create: true,
			docForm: {}
		}
	},
	methods: {
		getDocs() {
			this.loading = true
			SkyShopService.getBrigade().then(res => {
				this.docs = res.data
				this.loading = false
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		cancel() {
			this.docForm = {}
			this.loading = false
			this.createOrEditModal = false
			this.getDocs();
		},
		save() {
			if (this.docForm.name) {
				this.loading = true
				SkyShopService.saveBrigade(this.docForm, this.create).then(res => {
					this.cancel();
					this.loading = false
					this.$vs.notify({
						title: 'Успешно сохранено!',
						color: 'success',
						icon: 'close',
						position: 'top-right'
					});
				}).catch(e => {
					this.loading = false
					this.$vs.notify({
						title: e.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				})
			} else {
				this.$vs.notify({
					title: 'Заполните все обязательные поля!',
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			}
		}
	},
	created() {
		this.getDocs();
	}
}
</script>

<style scoped>
.pointer-event:hover {
	cursor: pointer;
}
</style>
